import type { TransportAdapter } from '../types';

export interface GtmAdapterOptions {
  dataLayerName?: string;
}

/**
 * `createGtmAdapter`. `creative-ui` has no equivalent, so this reimplements
 * the minimal subset of `@engie/web-components`'s tagging API used by this
 * app. Pushes every tagging event onto `window[dataLayerName]` for Google Tag
 * Manager to pick up.
 */
export function createGtmAdapter(
  options?: GtmAdapterOptions,
): TransportAdapter {
  const dataLayerName = options?.dataLayerName ?? 'dataLayer';

  return {
    id: 'gtm',
    track(event) {
      const dataLayer = (
        window as unknown as Record<string, unknown[] | undefined>
      )[dataLayerName];

      dataLayer?.push({
        event: event.name,
        ...(event.context ?? {}),
        ...(event.payload ?? {}),
        _ts: event.timestamp,
      });
    },
  };
}
